/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
    "/v1/admin/global-notifications": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * @description <!-- theme: info -->
         *     > ### 🔒 Authorization
         *     >
         *     > **Required Keycloak roles (any of):** `global-notification-create`, `tool-admin`
         */
        get: operations["global-notifications.admin.index"];
        put?: never;
        /**
         * @description <!-- theme: info -->
         *     > ### 🔒 Authorization
         *     >
         *     > **Required Keycloak roles (any of):** `global-notification-create`, `tool-admin`
         */
        post: operations["global-notifications.admin.store"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/admin/global-notifications/{globalNotification}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * @description <!-- theme: info -->
         *     > ### 🔒 Authorization
         *     >
         *     > **Required Keycloak roles (any of):** `global-notification-create`, `tool-admin`
         */
        get: operations["global-notifications.admin.show"];
        /**
         * @description <!-- theme: info -->
         *     > ### 🔒 Authorization
         *     >
         *     > **Required Keycloak roles (any of):** `global-notification-create`, `tool-admin`
         */
        put: operations["global-notifications.admin.update"];
        post?: never;
        /**
         * @description <!-- theme: info -->
         *     > ### 🔒 Authorization
         *     >
         *     > **Required Keycloak roles (any of):** `global-notification-create`, `tool-admin`
         */
        delete: operations["global-notifications.admin.destroy"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/admin/global-notifications/{id}/restore": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * @description <!-- theme: info -->
         *     > ### 🔒 Authorization
         *     >
         *     > **Required Keycloak roles (any of):** `global-notification-create`, `tool-admin`
         */
        post: operations["global-notifications.admin.restore"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/admin/global-notifications/config": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * @description <!-- theme: info -->
         *     > ### 🔒 Authorization
         *     >
         *     > **Required Keycloak roles (any of):** `global-notification-create`, `tool-admin`
         */
        get: operations["global-notifications.admin.config"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/admin/in-game-messages": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * @description <!-- theme: info -->
         *     > ### 🔒 Authorization
         *     >
         *     > **Required Keycloak roles (any of):** `in-game-message-viewer`, `tool-admin`
         */
        get: operations["in-game-messages.admin.index"];
        put?: never;
        /**
         * @description <!-- theme: info -->
         *     > ### 🔒 Authorization
         *     >
         *     > **Required Keycloak roles (any of):** `in-game-message-manager`, `tool-admin`
         */
        post: operations["in-game-messages.admin.store"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/admin/in-game-messages/{id}/restore": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * @description <!-- theme: info -->
         *     > ### 🔒 Authorization
         *     >
         *     > **Required Keycloak roles (any of):** `in-game-message-manager`, `tool-admin`
         */
        post: operations["in-game-messages.admin.restore"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/admin/in-game-messages/{inGameMessage}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * @description <!-- theme: info -->
         *     > ### 🔒 Authorization
         *     >
         *     > **Required Keycloak roles (any of):** `in-game-message-viewer`, `tool-admin`
         */
        get: operations["in-game-messages.admin.show"];
        /**
         * @description <!-- theme: info -->
         *     > ### 🔒 Authorization
         *     >
         *     > **Required Keycloak roles (any of):** `in-game-message-manager`, `tool-admin`
         */
        put: operations["in-game-messages.admin.update"];
        post?: never;
        /**
         * @description <!-- theme: info -->
         *     > ### 🔒 Authorization
         *     >
         *     > **Required Keycloak roles (any of):** `in-game-message-manager`, `tool-admin`
         */
        delete: operations["in-game-messages.admin.destroy"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/admin/in-game-messages/config": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * @description <!-- theme: info -->
         *     > ### 🔒 Authorization
         *     >
         *     > **Required Keycloak roles (any of):** `in-game-message-viewer`, `tool-admin`
         */
        get: operations["in-game-messages.admin.config"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/messaging/message-templates": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Display a listing of Message Templates.
         *     Also includes filtering for soft deleted items
         */
        get: operations["message-templates.index"];
        put?: never;
        /** Store a newly created resource in storage */
        post: operations["message-templates.store"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/messaging/message-templates/{id}/restore": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["message-templates.restore"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/messaging/message-templates/{messageTemplate}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Display the specified resource */
        get: operations["message-templates.show"];
        put: operations["message-templates.update"];
        post?: never;
        delete: operations["message-templates.destroy"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/messaging/message-templates/{messageTemplate}/send-test": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["message-templates.send-test"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/messaging/permissions/me": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["messaging.permissions.me"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/messaging/scheduled-messages": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Display a listing of Scheduled Messages.
         *     Also includes filtering for soft deleted items
         */
        get: operations["scheduled-messages.index"];
        put?: never;
        /** Store a newly created resource in storage */
        post: operations["scheduled-messages.store"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/messaging/scheduled-messages/{id}/restore": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["scheduled-messages.restore"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/messaging/scheduled-messages/{scheduledMessage}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put: operations["scheduled-messages.update"];
        post?: never;
        delete: operations["scheduled-messages.destroy"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/notification": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * @description <!-- theme: info -->
         *     > ### 🔒 Authorization
         *     >
         *     > **Required Keycloak role:** `notification-create`
         */
        post: operations["notification.create"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/notification/{externalUniqueId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * @description <!-- theme: info -->
         *     > ### 🔒 Authorization
         *     >
         *     > **Required Keycloak role:** `notification-delete`
         */
        delete: operations["notification.delete"];
        options?: never;
        head?: never;
        /**
         * @description <!-- theme: info -->
         *     > ### 🔒 Authorization
         *     >
         *     > **Required Keycloak role:** `notification-update`
         */
        patch: operations["notification.patch"];
        trace?: never;
    };
    "/v1/notification/{userId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Gets all notifications for a user
         * @description <!-- theme: info -->
         *     > ### 🔒 Authorization
         *     >
         *     > **Required Keycloak role:** `notification-read`
         */
        get: operations["notification.get_for_user"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/notification/{userId}/clear": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * @description <!-- theme: info -->
         *     > ### 🔒 Authorization
         *     >
         *     > **Required Keycloak role:** `notification-delete`
         */
        delete: operations["notification.clear_by_type"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/public/global-notifications": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["global.notification.get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/public/in-game-messages": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["in-game-message.get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/public/notifications": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get notifications for a user with various filters */
        get: operations["user.notification.get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/public/notifications/{notificationId}/accept": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Accept a notification */
        post: operations["user.notification.accept"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/public/notifications/{notificationId}/dismiss": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Dismiss a notification */
        post: operations["user.notification.dismiss"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/public/notifications/{notificationId}/shown": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Log that a notification has been viewed */
        post: operations["user.notification.shown"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/public/notifications/read": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Mark notifications as read */
        post: operations["user.notification.read"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
}
export type webhooks = Record<string, never>;
export interface components {
    schemas: {
        /** AccountAgeRule */
        AccountAgeRule: {
            min_account_age_days: number;
            /** @constant */
            type: "account_age";
        };
        /** AppOnlyRule */
        AppOnlyRule: {
            os: components["schemas"]["AppOS"] | null;
            /** @constant */
            type: "app_only";
        };
        /**
         * AppOS
         * @enum {string}
         */
        AppOS: AppOS;
        /**
         * Brand
         * @enum {string}
         */
        Brand: Brand;
        /** BrandRule */
        BrandRule: {
            brand: components["schemas"]["Brand"];
            /** @constant */
            type: "brand";
        };
        /** ClearNotificationsByTypeRequest */
        ClearNotificationsByTypeRequest: {
            type: components["schemas"]["MessageType"];
        };
        /** DeleteNotificationRequest */
        DeleteNotificationRequest: Record<string, never>;
        /**
         * EventType
         * @enum {string}
         */
        EventType: EventType;
        /** GetNotificationsForUserResponse */
        GetNotificationsForUserResponse: {
            notifications: components["schemas"]["RenderedNotification"][];
        };
        /** GetNotificationsRequest */
        GetNotificationsRequest: {
            /** @description Filter by presentation type, if provided */
            presentation_type?: components["schemas"]["PresentationType"];
            /** @description Filter by message state, if provided */
            state?: components["schemas"]["MessageState"];
            /**
             * @description Defaults to 'without' - i.e. return notifications that are not trashed
             * @enum {string}
             */
            trashed?: GetNotificationsRequestTrashed;
            /**
             * @description Filter by message type, if provided
             *
             *     | |
             *     |---|
             *     | `mentor_message` <br/>  |
             *     | `game_scanner` <br/>  |
             *     | `promotion_recurring_consent` <br/>  |
             *     | `game_launch` <br/>  |
             *     | `players_user_report_available` <br/>  |
             *     | `source_of_funds_request` <br/>  |
             *     | `affordability_limit_notification` <br/>  |
             *     | `money_limit_was_reverted` <br/>  |
             *     | `customize_username` <br/>  |
             *     | `withdrawal_status_update` <br/>  |
             *     | `suspended_after_extended_kyc_check` <br/>  |
             *     | `suspended_by_aml` <br/> Can be used if we want to provide an explanation to the user when a suspension occurs. |
             *     | `occupation_check` <br/>  |
             *     | `salary_check` <br/>  |
             *     | `bounce_email_review_profile` <br/>  |
             *     | `promotion_game` <br/>  |
             *     | `kyc_document_inquiry` <br/>  |
             *     | `kyc_document_approved` <br/>  |
             *     | `kyc_document_denied` <br/>  |
             *     | `app_review_request` <br/>  |
             *     | `promotion_bonus_redeemed` <br/>  |
             *     | `promotion_first_deposit_bonus_redeemed` <br/>  |
             *     | `money_limits_reminder` <br/>  |
             *     | `additional_information_request` <br/>  |
             *     | `biometric_login_request` <br/>  |
             *     | `withdrawal_request_approved` <br/>  |
             */
            type?: components["schemas"]["MessageType"];
        };
        /** GetPaginatedNotificationRequest */
        GetPaginatedNotificationRequest: {
            brand?: components["schemas"]["Brand"] | null;
            category?: components["schemas"]["MessageCategory"] | null;
            channel?: components["schemas"]["NotificationChannel"] | null;
            /**
             * @description Whether to exclude expired notifications
             * @default false
             */
            exclude_expired?: boolean | null;
            /**
             * @description Whether to exclude read notifications
             * @default false
             */
            exclude_read?: boolean | null;
            limit: number;
            offset: number;
            presentation_type?: components["schemas"]["PresentationType"] | null;
        };
        /** GetRawNotificationsForUserResponse */
        GetRawNotificationsForUserResponse: {
            notifications: components["schemas"]["Notification"][];
        };
        /** GlobalNotificationActiveFilterData */
        GlobalNotificationActiveFilterData: {
            brand?: components["schemas"]["Brand"] | null;
            channel?: components["schemas"]["NotificationChannel"] | null;
            path?: string | null;
            placement?: components["schemas"]["GlobalNotificationPlacement"] | null;
        };
        /** GlobalNotificationData */
        GlobalNotificationData: {
            body: string;
            brands?: string[] | null;
            /** @default any */
            channel?: components["schemas"]["NotificationChannel"];
            dismissible: boolean;
            /** Format: date-time */
            ends_at?: string | null;
            is_active: boolean;
            placement: components["schemas"]["GlobalNotificationPlacement"];
            severity: components["schemas"]["GlobalNotificationSeverity"];
            staff_only: boolean;
            /** Format: date-time */
            starts_at?: string | null;
            title: string;
            url_path_prefix?: string | null;
        };
        /**
         * GlobalNotificationPlacement
         * @enum {string}
         */
        GlobalNotificationPlacement: GlobalNotificationPlacement;
        /** GlobalNotificationResponse */
        GlobalNotificationResponse: {
            body: string;
            brands: string[];
            channel: components["schemas"]["NotificationChannel"];
            /** Format: date-time */
            created_at: string | null;
            /** Format: date-time */
            deleted_at: string | null;
            dismissible: boolean;
            /** Format: date-time */
            ends_at: string | null;
            id: number;
            is_active: boolean;
            placement: components["schemas"]["GlobalNotificationPlacement"];
            severity: components["schemas"]["GlobalNotificationSeverity"];
            staff_only: boolean;
            /** Format: date-time */
            starts_at: string | null;
            title: string;
            /** Format: date-time */
            updated_at: string | null;
            url_path_prefix: string | null;
        };
        /**
         * GlobalNotificationSeverity
         * @enum {string}
         */
        GlobalNotificationSeverity: GlobalNotificationSeverity;
        /** InGameMessageActiveFilterData */
        InGameMessageActiveFilterData: {
            brand?: components["schemas"]["Brand"] | null;
            game_slug?: string | null;
        };
        /** InGameMessageData */
        InGameMessageData: {
            body: string;
            brands?: string[] | null;
            button_text?: string | null;
            /** Format: date-time */
            ends_at: string;
            game_slugs?: string[] | null;
            image_height?: number | null;
            image_url?: string | null;
            image_width?: number | null;
            is_active: boolean;
            /** @description Minimum minutes between displays; null means show once per campaign */
            recurring_interval_minutes?: number | null;
            /** Format: date-time */
            starts_at: string;
            title: string;
        };
        /** InGameMessageResponse */
        InGameMessageResponse: {
            body: string;
            body_html: string;
            brands: string[];
            button_text: string | null;
            /** Format: date-time */
            created_at: string | null;
            /** Format: date-time */
            deleted_at: string | null;
            /** Format: date-time */
            ends_at: string;
            game_slugs: string[];
            id: number;
            image_height: number | null;
            image_url: string | null;
            image_width: number | null;
            is_active: boolean;
            /** @description Minimum minutes between displays; null means show once per campaign */
            recurring_interval_minutes: number | null;
            /** Format: date-time */
            starts_at: string;
            title: string;
            /** Format: date-time */
            updated_at: string | null;
        };
        /** IsStaffRule */
        IsStaffRule: {
            /** @constant */
            type: "is_staff";
        };
        /** MarkNotificationsAsReadRequest */
        MarkNotificationsAsReadRequest: {
            /** @description The ids of the notifications to mark as read. If not provided, all notifications will be marked as read */
            notificationIds?: string[] | null;
        };
        /**
         * MessageCategory
         * @enum {string}
         */
        MessageCategory: MessageCategory;
        /**
         * MessageState
         * @enum {string}
         */
        MessageState: MessageState;
        /** MessageTemplate */
        MessageTemplate: {
            body: string | null;
            /** Format: date-time */
            created_at: string | null;
            data: {
                [key: string]: unknown;
            } | null;
            /** Format: date-time */
            deleted_at: string | null;
            id: number;
            message_type: components["schemas"]["MessageType"];
            name: string;
            presentation_type: components["schemas"]["PresentationType"];
            priority: number;
            title: string;
            /** Format: date-time */
            updated_at: string | null;
        };
        /** MessageTemplateData */
        MessageTemplateData: {
            actions?: components["schemas"]["TemplateActionData"][] | null;
            body?: string | null;
            /** @default [] */
            data?: unknown[] | null;
            message_type: components["schemas"]["MessageType"];
            name: string;
            presentation_type: components["schemas"]["PresentationType"];
            priority: number;
            title: string;
        };
        /** MessageTemplateFilterData */
        MessageTemplateFilterData: {
            /** @enum {string|null} */
            trashed?: "only" | "with" | "without" | null;
        };
        /**
         * MessageType
         * @description | |
         *     |---|
         *     | `mentor_message` <br/>  |
         *     | `game_scanner` <br/>  |
         *     | `promotion_recurring_consent` <br/>  |
         *     | `game_launch` <br/>  |
         *     | `players_user_report_available` <br/>  |
         *     | `source_of_funds_request` <br/>  |
         *     | `affordability_limit_notification` <br/>  |
         *     | `money_limit_was_reverted` <br/>  |
         *     | `customize_username` <br/>  |
         *     | `withdrawal_status_update` <br/>  |
         *     | `suspended_after_extended_kyc_check` <br/>  |
         *     | `suspended_by_aml` <br/> Can be used if we want to provide an explanation to the user when a suspension occurs. |
         *     | `occupation_check` <br/>  |
         *     | `salary_check` <br/>  |
         *     | `bounce_email_review_profile` <br/>  |
         *     | `promotion_game` <br/>  |
         *     | `kyc_document_inquiry` <br/>  |
         *     | `kyc_document_approved` <br/>  |
         *     | `kyc_document_denied` <br/>  |
         *     | `app_review_request` <br/>  |
         *     | `promotion_bonus_redeemed` <br/>  |
         *     | `promotion_first_deposit_bonus_redeemed` <br/>  |
         *     | `money_limits_reminder` <br/>  |
         *     | `additional_information_request` <br/>  |
         *     | `biometric_login_request` <br/>  |
         *     | `withdrawal_request_approved` <br/>  |
         * @enum {string}
         */
        MessageType: MessageType;
        /** MinAppLoginCountRule */
        MinAppLoginCountRule: {
            min_app_login_count: number;
            /** @constant */
            type: "min_app_login_count";
        };
        /** MinLoginCountRule */
        MinLoginCountRule: {
            min_login_count: number;
            /** @constant */
            type: "min_login_count";
        };
        /** Notification */
        Notification: {
            acceptAction: components["schemas"]["NotificationAction"] | null;
            /** @description The body of the notification shown to the user. Should be translated. Can use Liquid syntax. HTML welcome */
            body: string | null;
            brand: components["schemas"]["Brand"] | null;
            /**
             * Format: date-time
             * @description The time the notification was created
             */
            createdAt: string;
            /**
             * @description The data of the notification shown to the user. Can be used in the Liquid template, and will be returned in callbacks
             * @default []
             */
            data: {
                [key: string]: unknown;
            };
            dismissAction: components["schemas"]["NotificationAction"] | null;
            /**
             * Format: date-time
             * @description The time the notification should be displayed as created. If not provided, the current timestamp will be used
             */
            displayedCreatedAt: string | null;
            /**
             * Format: date-time
             * @description If not null, the time the notification should be marked as expired
             */
            expiresAt: string | null;
            externalUniqueId: string;
            /** @description The unique identifier for the notification */
            id: string;
            presentationType: components["schemas"]["PresentationType"] | null;
            priority: number;
            /** @description Whether the notification has been read by the user */
            read: boolean;
            /**
             * Format: date-time
             * @description The time the notification was read by the user
             */
            readAt: string | null;
            /** @description The session id of the user that read the notification */
            readBySessionId: number | null;
            state: components["schemas"]["MessageState"];
            /** @description The title of the notification shown to the user. Should be translated. Can use Liquid syntax. Do not use HTML tags */
            title: string;
            type: components["schemas"]["MessageType"];
            /**
             * Format: date-time
             * @description The time the notification was last updated
             */
            updatedAt: string;
            userId: number;
        };
        /** NotificationAction */
        NotificationAction: {
            /**
             * @description The reaction action to take on the notification once the action has been taken. Defaults to REMOVE_ACCEPT
             * @default REMOVE_ACCEPT
             */
            reaction: components["schemas"]["NotificationReactionAction"];
            redirect: string | null;
            /** @description The text of the action button. If not set, no action button will be shown. Supports blade syntax. Do not use HTML tags */
            template: string | null;
            /** @description The webhook to call when the user has clicked the action button. Will be a POST request, @see App\DataTransferObjects\Notification\WebhookRequest */
            webhook: string | null;
        };
        /** NotificationActionRequest */
        NotificationActionRequest: {
            /**
             * @description The reaction action to take on the notification once the action has been taken. Defaults to REMOVE_ACCEPT
             * @default REMOVE_ACCEPT
             */
            reaction?: components["schemas"]["NotificationReactionAction"];
            redirect?: string | null;
            /** @description The text of the action button. If not set, no action button will be shown. Supports blade syntax. Do not use HTML tags */
            template?: string | null;
            /** @description The webhook to call when the user has clicked the action button. Will be a POST request, @see App\DataTransferObjects\Notification\WebhookRequest */
            webhook?: string | null;
        };
        /**
         * NotificationActionType
         * @enum {string}
         */
        NotificationActionType: NotificationActionType;
        /**
         * NotificationChannel
         * @enum {string}
         */
        NotificationChannel: NotificationChannel;
        /**
         * NotificationReactionAction
         * @enum {string}
         */
        NotificationReactionAction: NotificationReactionAction;
        /** PatchNotificationRequest */
        PatchNotificationRequest: {
            acceptAction?: components["schemas"]["NotificationActionRequest"] | null;
            /** @description The body of the notification shown to the user. Should be translated. Can use Liquid syntax. HTML welcome */
            body?: string | null;
            brand?: components["schemas"]["Brand"] | null;
            /** @description The data of the notification shown to the user. Can be used in the Liquid template, and will be returned in callbacks */
            data?: Record<string, never>[];
            dismissAction?: components["schemas"]["NotificationActionRequest"] | null;
            /**
             * Format: date-time
             * @description If not null, the time the notification should be sent
             */
            expiresAt?: string | null;
            state?: components["schemas"]["MessageState"];
            /** @description The title of the notification shown to the user. Should be translated. Can use Liquid syntax. Do not use HTML tags */
            title?: string;
        };
        /**
         * PresentationType
         * @enum {string}
         */
        PresentationType: PresentationType;
        /** RenderedNotification */
        RenderedNotification: {
            acceptAction: components["schemas"]["RenderedNotificationAction"] | null;
            /** @description The body of the notification */
            body: string | null;
            channel: components["schemas"]["NotificationChannel"] | null;
            /**
             * Format: date-time
             * @description The time the notification was created
             */
            created_at: string;
            /** @description Contextual data for the notification */
            data: {
                [key: string]: unknown;
            };
            dismissAction: components["schemas"]["RenderedNotificationAction"] | null;
            /**
             * Format: date-time
             * @description The time the notification should be showen as created
             */
            displayed_created_at: string;
            /**
             * Format: date-time
             * @description The time the notification expires
             */
            expires_at: string | null;
            /** @description The unique external identifier for the notification */
            externalUniqueId: string;
            /** @description The unique identifier for the notification must be a UUID */
            id: string;
            /** @description The presentation type for the notification */
            presentation_type: components["schemas"]["PresentationType"];
            /** @description Priority of the notification, higher numbers indicate higher priority */
            priority: number;
            /** @description Whether the notification has been read */
            read: boolean;
            /**
             * Format: date-time
             * @description The time the notification was read
             */
            read_at: string | null;
            /** @description The state of the notification */
            state: components["schemas"]["MessageState"];
            /** @description The title of the notification */
            title: string;
            /**
             * @description The slug/type of the notification, typically used to group notifications into types
             *
             *     | |
             *     |---|
             *     | `mentor_message` <br/>  |
             *     | `game_scanner` <br/>  |
             *     | `promotion_recurring_consent` <br/>  |
             *     | `game_launch` <br/>  |
             *     | `players_user_report_available` <br/>  |
             *     | `source_of_funds_request` <br/>  |
             *     | `affordability_limit_notification` <br/>  |
             *     | `money_limit_was_reverted` <br/>  |
             *     | `customize_username` <br/>  |
             *     | `withdrawal_status_update` <br/>  |
             *     | `suspended_after_extended_kyc_check` <br/>  |
             *     | `suspended_by_aml` <br/> Can be used if we want to provide an explanation to the user when a suspension occurs. |
             *     | `occupation_check` <br/>  |
             *     | `salary_check` <br/>  |
             *     | `bounce_email_review_profile` <br/>  |
             *     | `promotion_game` <br/>  |
             *     | `kyc_document_inquiry` <br/>  |
             *     | `kyc_document_approved` <br/>  |
             *     | `kyc_document_denied` <br/>  |
             *     | `app_review_request` <br/>  |
             *     | `promotion_bonus_redeemed` <br/>  |
             *     | `promotion_first_deposit_bonus_redeemed` <br/>  |
             *     | `money_limits_reminder` <br/>  |
             *     | `additional_information_request` <br/>  |
             *     | `biometric_login_request` <br/>  |
             *     | `withdrawal_request_approved` <br/>  |
             */
            type: components["schemas"]["MessageType"];
        };
        /** RenderedNotificationAction */
        RenderedNotificationAction: {
            /** @description The callback URL which should be called when the user clicks the button by the frontend */
            callback: string;
            /** @description The redirect, if not null, that should be redirected to once the action has been taken and the callback has been called */
            redirect: string | null;
            /** @description The rendered text of the action button */
            text: string;
        };
        /** ScheduledMessage */
        ScheduledMessage: {
            /** Format: date-time */
            created_at: string | null;
            /** Format: date-time */
            deleted_at: string | null;
            description: string | null;
            event_types: Record<string, never>;
            /** Format: date-time */
            expires_at: string | null;
            id: number;
            is_recurring: boolean;
            max_send_count: number | null;
            max_send_count_per_user: number | null;
            recurring_interval_minutes: number | null;
            rules: {
                global?: (components["schemas"]["AppOnlyRule"] | components["schemas"]["AccountAgeRule"] | components["schemas"]["IsStaffRule"] | components["schemas"]["BrandRule"] | components["schemas"]["UsernameShouldBeAutogeneratedRule"])[];
                user_logged_in?: (components["schemas"]["AppOnlyRule"] | components["schemas"]["AccountAgeRule"] | components["schemas"]["IsStaffRule"] | components["schemas"]["BrandRule"] | components["schemas"]["SkipFirstSessionRule"] | components["schemas"]["UsernameShouldBeAutogeneratedRule"] | components["schemas"]["MinLoginCountRule"] | components["schemas"]["MinAppLoginCountRule"])[];
                user_made_withdrawal?: (components["schemas"]["AppOnlyRule"] | components["schemas"]["AccountAgeRule"] | components["schemas"]["IsStaffRule"] | components["schemas"]["BrandRule"] | components["schemas"]["UsernameShouldBeAutogeneratedRule"])[];
            } | null;
            /** Format: date-time */
            scheduled_from: string | null;
            /** Format: date-time */
            scheduled_to: string | null;
            state: components["schemas"]["ScheduledMessageState"];
            template_id: number;
            /** Format: date-time */
            updated_at: string | null;
        };
        /** ScheduledMessageData */
        ScheduledMessageData: {
            description?: string | null;
            event_types: components["schemas"]["EventType"][];
            /** Format: date-time */
            expires_at?: string | null;
            is_recurring: boolean;
            max_send_count?: number | null;
            max_send_count_per_user?: number | null;
            recurring_interval_minutes?: number | null;
            /** @description Rules grouped by 'global' or event type; event-specific rule types are only valid under events they support. */
            rules?: {
                global?: (components["schemas"]["AppOnlyRule"] | components["schemas"]["AccountAgeRule"] | components["schemas"]["IsStaffRule"] | components["schemas"]["BrandRule"] | components["schemas"]["UsernameShouldBeAutogeneratedRule"])[];
                user_logged_in?: (components["schemas"]["AppOnlyRule"] | components["schemas"]["AccountAgeRule"] | components["schemas"]["IsStaffRule"] | components["schemas"]["BrandRule"] | components["schemas"]["SkipFirstSessionRule"] | components["schemas"]["UsernameShouldBeAutogeneratedRule"] | components["schemas"]["MinLoginCountRule"] | components["schemas"]["MinAppLoginCountRule"])[];
                user_made_withdrawal?: (components["schemas"]["AppOnlyRule"] | components["schemas"]["AccountAgeRule"] | components["schemas"]["IsStaffRule"] | components["schemas"]["BrandRule"] | components["schemas"]["UsernameShouldBeAutogeneratedRule"])[];
            } | null;
            /** Format: date-time */
            scheduled_from?: string | null;
            /** Format: date-time */
            scheduled_to?: string | null;
            state?: components["schemas"]["ScheduledMessageState"] | null;
            template_id: number;
        };
        /** ScheduledMessageFilterData */
        ScheduledMessageFilterData: {
            /** @enum {string|null} */
            trashed?: "only" | "with" | "without" | null;
        };
        /**
         * ScheduledMessageState
         * @enum {string}
         */
        ScheduledMessageState: ScheduledMessageState;
        /** SendNotificationRequest */
        SendNotificationRequest: {
            acceptAction?: components["schemas"]["NotificationActionRequest"] | null;
            /** @description The body of the notification shown to the user. Should be translated. Can use Liquid syntax. HTML welcome */
            body?: string | null;
            brand?: components["schemas"]["Brand"] | null;
            /**
             * @description The data of the notification shown to the user. Can be used in the Liquid template, and will be returned in callbacks
             * @default []
             */
            data?: {
                [key: string]: unknown;
            };
            dismissAction?: components["schemas"]["NotificationActionRequest"] | null;
            /**
             * Format: date-time
             * @description The time the notification should be displayed as created. If not provided, the current timestamp will be used
             */
            displayedCreatedAt?: string | null;
            /**
             * Format: date-time
             * @description If not null, the time the notification should be marked as expired
             */
            expiresAt?: string | null;
            externalUniqueId: string;
            presentationType?: components["schemas"]["PresentationType"] | null;
            priority: number;
            state: components["schemas"]["MessageState"];
            /** @description The title of the notification shown to the user. Should be translated. Can use Liquid syntax. Do not use HTML tags */
            title: string;
            type: components["schemas"]["MessageType"];
            userId: number;
        };
        /** SendNotificationResponse */
        SendNotificationResponse: {
            /** @description The unique identifier for the notification */
            id: string;
        };
        /** SendTestNotificationData */
        SendTestNotificationData: {
            /** Format: email */
            email: string;
        };
        /** SkipFirstSessionRule */
        SkipFirstSessionRule: {
            /** @constant */
            type: "skip_first_session";
        };
        /** TemplateActionData */
        TemplateActionData: {
            reaction: components["schemas"]["NotificationReactionAction"];
            redirect?: string | null;
            template: string;
            type: components["schemas"]["NotificationActionType"];
            webhook?: string | null;
        };
        /** TrashedFilterData */
        TrashedFilterData: {
            /** @enum {string|null} */
            trashed?: "only" | "with" | "without" | null;
        };
        /** UsernameShouldBeAutogeneratedRule */
        UsernameShouldBeAutogeneratedRule: {
            /** @constant */
            type: "username_should_be_autogenerated";
        };
    };
    responses: {
        /** @description Unauthenticated */
        AuthenticationException: {
            headers: {
                [name: string]: unknown;
            };
            content: {
                "application/json": {
                    /** @description Error overview. */
                    message: string;
                };
            };
        };
        /** @description Authorization error */
        AuthorizationException: {
            headers: {
                [name: string]: unknown;
            };
            content: {
                "application/json": {
                    /** @description Error overview. */
                    message: string;
                };
            };
        };
        /** @description Not found */
        ModelNotFoundException: {
            headers: {
                [name: string]: unknown;
            };
            content: {
                "application/json": {
                    /** @description Error overview. */
                    message: string;
                };
            };
        };
        /** @description Validation error */
        ValidationException: {
            headers: {
                [name: string]: unknown;
            };
            content: {
                "application/json": {
                    /** @description A detailed description of each field that failed validation. */
                    errors: {
                        [key: string]: string[];
                    };
                    /** @description Errors overview. */
                    message: string;
                };
            };
        };
    };
    parameters: never;
    requestBodies: never;
    headers: never;
    pathItems: never;
}
export type $defs = Record<string, never>;
export interface operations {
    "global-notifications.admin.index": {
        parameters: {
            query?: {
                trashed?: "only" | "with" | "without" | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GlobalNotificationResponse"][];
                };
            };
            401: components["responses"]["AuthenticationException"];
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "global-notifications.admin.store": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `GlobalNotificationData` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["GlobalNotificationData"];
            };
        };
        responses: {
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        id: number;
                        message: string;
                    };
                };
            };
            401: components["responses"]["AuthenticationException"];
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "global-notifications.admin.show": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The global notification ID */
                globalNotification: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `GlobalNotificationResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GlobalNotificationResponse"];
                };
            };
            401: components["responses"]["AuthenticationException"];
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
        };
    };
    "global-notifications.admin.update": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The global notification ID */
                globalNotification: number;
            };
            cookie?: never;
        };
        /** @description `GlobalNotificationData` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["GlobalNotificationData"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @constant */
                        message: "Global notification updated successfully";
                    };
                };
            };
            401: components["responses"]["AuthenticationException"];
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "global-notifications.admin.destroy": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The global notification ID */
                globalNotification: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @constant */
                        message: "Global notification deleted successfully";
                    };
                };
            };
            401: components["responses"]["AuthenticationException"];
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
        };
    };
    "global-notifications.admin.restore": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @constant */
                        message: "Global notification restored successfully";
                    };
                };
            };
            401: components["responses"]["AuthenticationException"];
            403: components["responses"]["AuthorizationException"];
        };
    };
    "global-notifications.admin.config": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        brands: {
                            prettyName: string;
                            value: string;
                        }[];
                        channels: string[];
                        jurisdiction: string | null;
                        placements: string[];
                        severities: string[];
                    };
                };
            };
            401: components["responses"]["AuthenticationException"];
            403: components["responses"]["AuthorizationException"];
        };
    };
    "in-game-messages.admin.index": {
        parameters: {
            query?: {
                trashed?: "only" | "with" | "without" | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["InGameMessageResponse"][];
                };
            };
            401: components["responses"]["AuthenticationException"];
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "in-game-messages.admin.store": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `InGameMessageData` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["InGameMessageData"];
            };
        };
        responses: {
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        id: number;
                        message: string;
                    };
                };
            };
            401: components["responses"]["AuthenticationException"];
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "in-game-messages.admin.restore": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @constant */
                        message: "In-game message restored successfully";
                    };
                };
            };
            401: components["responses"]["AuthenticationException"];
            403: components["responses"]["AuthorizationException"];
        };
    };
    "in-game-messages.admin.show": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The in game message ID */
                inGameMessage: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `InGameMessageResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["InGameMessageResponse"];
                };
            };
            401: components["responses"]["AuthenticationException"];
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
        };
    };
    "in-game-messages.admin.update": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The in game message ID */
                inGameMessage: number;
            };
            cookie?: never;
        };
        /** @description `InGameMessageData` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["InGameMessageData"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @constant */
                        message: "In-game message updated successfully";
                    };
                };
            };
            401: components["responses"]["AuthenticationException"];
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "in-game-messages.admin.destroy": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The in game message ID */
                inGameMessage: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @constant */
                        message: "In-game message deleted successfully";
                    };
                };
            };
            401: components["responses"]["AuthenticationException"];
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
        };
    };
    "in-game-messages.admin.config": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        brands: {
                            prettyName: string;
                            value: string;
                        }[];
                        jurisdiction: string | null;
                        permissions: {
                            manage: boolean;
                            view: boolean;
                        };
                    };
                };
            };
            401: components["responses"]["AuthenticationException"];
            403: components["responses"]["AuthorizationException"];
        };
    };
    "message-templates.index": {
        parameters: {
            query?: {
                trashed?: "only" | "with" | "without" | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["MessageTemplate"][];
                };
            };
            401: components["responses"]["AuthenticationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "message-templates.store": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `MessageTemplateData` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["MessageTemplateData"];
            };
        };
        responses: {
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @constant */
                        message: "Message template created successfully";
                    };
                };
            };
            401: components["responses"]["AuthenticationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "message-templates.restore": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @constant */
                        message: "Message template restored successfully";
                    };
                };
            };
            401: components["responses"]["AuthenticationException"];
        };
    };
    "message-templates.show": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The message template ID */
                messageTemplate: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["MessageTemplate"];
                };
            };
            401: components["responses"]["AuthenticationException"];
            404: components["responses"]["ModelNotFoundException"];
        };
    };
    "message-templates.update": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The message template ID */
                messageTemplate: number;
            };
            cookie?: never;
        };
        /** @description `MessageTemplateData` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["MessageTemplateData"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @constant */
                        message: "Message template updated successfully";
                    };
                };
            };
            401: components["responses"]["AuthenticationException"];
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "message-templates.destroy": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The message template ID */
                messageTemplate: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @constant */
                        message: "Message template deleted successfully";
                    };
                };
            };
            401: components["responses"]["AuthenticationException"];
            404: components["responses"]["ModelNotFoundException"];
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @constant */
                        message: "Message template is in use by scheduled messages";
                        scheduled_messages_count: string;
                    };
                };
            };
        };
    };
    "message-templates.send-test": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The message template ID */
                messageTemplate: number;
            };
            cookie?: never;
        };
        /** @description `SendTestNotificationData` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["SendTestNotificationData"];
            };
        };
        responses: {
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        message: string;
                        notification_id: Record<string, never>;
                    };
                };
            };
            401: components["responses"]["AuthenticationException"];
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @constant */
                        message: "User is not staff";
                    };
                };
            };
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "messaging.permissions.me": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        permissions: {
                            [key: string]: {
                                event_types: string[];
                                message_types: string[];
                                presentation_types: string[];
                            };
                        };
                    };
                };
            };
            401: components["responses"]["AuthenticationException"];
        };
    };
    "scheduled-messages.index": {
        parameters: {
            query?: {
                trashed?: "only" | "with" | "without" | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ScheduledMessage"][];
                };
            };
            401: components["responses"]["AuthenticationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "scheduled-messages.store": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `ScheduledMessageData` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["ScheduledMessageData"];
            };
        };
        responses: {
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @constant */
                        message: "Scheduled message created successfully";
                    };
                };
            };
            401: components["responses"]["AuthenticationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "scheduled-messages.restore": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @constant */
                        message: "Scheduled message restored successfully";
                    };
                };
            };
            401: components["responses"]["AuthenticationException"];
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @constant */
                        message: "The template for this scheduled message is deleted. Restore the template first.";
                    };
                };
            };
        };
    };
    "scheduled-messages.update": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The scheduled message ID */
                scheduledMessage: number;
            };
            cookie?: never;
        };
        /** @description `ScheduledMessageData` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["ScheduledMessageData"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @constant */
                        message: "Scheduled message updated successfully";
                    };
                };
            };
            401: components["responses"]["AuthenticationException"];
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "scheduled-messages.destroy": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The scheduled message ID */
                scheduledMessage: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @constant */
                        message: "Scheduled message deleted successfully";
                    };
                };
            };
            401: components["responses"]["AuthenticationException"];
            404: components["responses"]["ModelNotFoundException"];
        };
    };
    "notification.create": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `SendNotificationRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["SendNotificationRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": string;
                };
            };
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "notification.delete": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                externalUniqueId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description No content */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "notification.patch": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                externalUniqueId: string;
            };
            cookie?: never;
        };
        /** @description `PatchNotificationRequest` */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["PatchNotificationRequest"];
            };
        };
        responses: {
            /** @description `SendNotificationResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SendNotificationResponse"];
                };
            };
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "notification.get_for_user": {
        parameters: {
            query?: {
                presentation_type?: components["schemas"]["PresentationType"];
                state?: components["schemas"]["MessageState"];
                trashed?: PathsV1NotificationUserIdGetParametersQueryTrashed;
                type?: components["schemas"]["MessageType"];
            };
            header?: never;
            path: {
                userId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `GetRawNotificationsForUserResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GetRawNotificationsForUserResponse"];
                };
            };
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "notification.clear_by_type": {
        parameters: {
            query: {
                type: components["schemas"]["MessageType"];
            };
            header?: never;
            path: {
                userId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description No content */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "global.notification.get": {
        parameters: {
            query?: {
                brand?: components["schemas"]["Brand"] | null;
                channel?: components["schemas"]["NotificationChannel"] | null;
                path?: string | null;
                placement?: components["schemas"]["GlobalNotificationPlacement"] | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GlobalNotificationResponse"][];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "in-game-message.get": {
        parameters: {
            query?: {
                brand?: components["schemas"]["Brand"] | null;
                game_slug?: string | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["InGameMessageResponse"][];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "user.notification.get": {
        parameters: {
            query: {
                brand?: components["schemas"]["Brand"] | null;
                category?: components["schemas"]["MessageCategory"] | null;
                channel?: components["schemas"]["NotificationChannel"] | null;
                exclude_expired?: boolean | null;
                exclude_read?: boolean | null;
                limit: number;
                offset: number;
                presentation_type?: components["schemas"]["PresentationType"] | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `GetNotificationsForUserResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GetNotificationsForUserResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "user.notification.accept": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                notificationId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `RenderedNotification` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["RenderedNotification"];
                };
            };
        };
    };
    "user.notification.dismiss": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                notificationId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `RenderedNotification` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["RenderedNotification"];
                };
            };
        };
    };
    "user.notification.shown": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                notificationId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
        };
    };
    "user.notification.read": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `MarkNotificationsAsReadRequest` */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["MarkNotificationsAsReadRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
}
export enum PathsV1NotificationUserIdGetParametersQueryTrashed {
    only = "only",
    with = "with",
    without = "without"
}
export enum AppOS {
    iOS = "iOS",
    Android = "Android"
}
export enum Brand {
    spilnu = "spilnu",
    happytiger = "happytiger",
    spinking = "spinking",
    bingoburst = "bingoburst",
    luxcasino = "luxcasino",
    sweetspin = "sweetspin",
    jackpotfisher = "jackpotfisher",
    spinnow = "spinnow",
    crushit = "crushit"
}
export enum EventType {
    user_logged_in = "user_logged_in",
    user_made_withdrawal = "user_made_withdrawal"
}
export enum GetNotificationsRequestTrashed {
    only = "only",
    with = "with",
    without = "without"
}
export enum GlobalNotificationPlacement {
    top_banner = "top_banner",
    login_modal = "login_modal",
    payment_page = "payment_page",
    chat = "chat"
}
export enum GlobalNotificationSeverity {
    info = "info",
    warning = "warning",
    critical = "critical"
}
export enum MessageCategory {
    News = "News",
    Promotion = "Promotion",
    Other = "Other"
}
export enum MessageState {
    active = "active",
    expired = "expired",
    accepted = "accepted",
    rejected = "rejected"
}
export enum MessageType {
    mentor_message = "mentor_message",
    game_scanner = "game_scanner",
    promotion_recurring_consent = "promotion_recurring_consent",
    game_launch = "game_launch",
    players_user_report_available = "players_user_report_available",
    source_of_funds_request = "source_of_funds_request",
    affordability_limit_notification = "affordability_limit_notification",
    money_limit_was_reverted = "money_limit_was_reverted",
    customize_username = "customize_username",
    withdrawal_status_update = "withdrawal_status_update",
    suspended_after_extended_kyc_check = "suspended_after_extended_kyc_check",
    suspended_by_aml = "suspended_by_aml",
    occupation_check = "occupation_check",
    salary_check = "salary_check",
    bounce_email_review_profile = "bounce_email_review_profile",
    promotion_game = "promotion_game",
    kyc_document_inquiry = "kyc_document_inquiry",
    kyc_document_approved = "kyc_document_approved",
    kyc_document_denied = "kyc_document_denied",
    app_review_request = "app_review_request",
    promotion_bonus_redeemed = "promotion_bonus_redeemed",
    promotion_first_deposit_bonus_redeemed = "promotion_first_deposit_bonus_redeemed",
    money_limits_reminder = "money_limits_reminder",
    additional_information_request = "additional_information_request",
    biometric_login_request = "biometric_login_request",
    withdrawal_request_approved = "withdrawal_request_approved"
}
export enum NotificationActionType {
    ACCEPT = "ACCEPT",
    DISMISS = "DISMISS"
}
export enum NotificationChannel {
    any = "any",
    app = "app",
    web = "web"
}
export enum NotificationReactionAction {
    NONE = "NONE",
    REMOVE_ACCEPT = "REMOVE_ACCEPT",
    REMOVE_DISMISS = "REMOVE_DISMISS",
    REMOVE_ACTIONS = "REMOVE_ACTIONS"
}
export enum PresentationType {
    notification = "notification",
    dialog = "dialog",
    flash = "flash",
    persistent_dialog = "persistent_dialog"
}
export enum ScheduledMessageState {
    draft = "draft",
    active = "active",
    paused = "paused",
    reached_cap = "reached_cap",
    ended = "ended"
}
